import axios from "axios"

export async function getTableauToken (): Promise<string> {
  return (await axios.get(`/api/admin/tableau/token`)).data
}